import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { Layout, Grid } from "antd";
import closeIcon from "@/assets/images/close.svg";
const { Footer: AntFooter } = Layout;

export const Footer: React.FC = () => {
  const { t } = useTranslation();
  const [showBetaButton, setShowBetaButton] = useState(true);
  const [isContactUsOpen, setIsContactUsOpen] = useState(false);
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;
  const auditStatus = localStorage.getItem("audit_status");
  console.log("auditStatus", auditStatus);
  console.log("showBetaButton", showBetaButton);

  // 监听 NewContactUs 页面的打开和关闭状态
  useEffect(() => {
    const handleContactOpen = () => {
      setIsContactUsOpen(true);
      // 同时隐藏悬浮按钮
      setShowBetaButton(false);
    };

    const handleContactClose = () => {
      setIsContactUsOpen(false);
      // 检查 auditStatus 决定是否显示悬浮按钮
      const auditStatus = localStorage.getItem("audit_status");
      if (auditStatus !== "1" && auditStatus !== "2") {
        setShowBetaButton(true);
      }
    };

    // 监听全局事件
    window.addEventListener("globalSelectContact", handleContactOpen);
    window.addEventListener("contactUsClosed", handleContactClose);

    // 检查初始状态
    const contactOpenElement = document.querySelector("[data-contact-us-page]");
    if (contactOpenElement) {
      setIsContactUsOpen(true);
      setShowBetaButton(false);
    }

    return () => {
      window.removeEventListener("globalSelectContact", handleContactOpen);
      window.removeEventListener("contactUsClosed", handleContactClose);
    };
  }, []);

  // 加入内测联盟功能 - 复用头部导航的逻辑
  const joinBetaProgram = (e: React.MouseEvent) => {
    // 阻止事件冒泡，避免同时触发关闭按钮
    e.stopPropagation();
    // 触发全局事件，打开内测联盟弹窗
    const event = new CustomEvent("globalSelectContact");
    window.dispatchEvent(event);
  };

  // 关闭内测联盟按钮
  const closeBetaButton = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowBetaButton(false);
  };

  return (
    <AntFooter
      style={{
        background: "#f8fafc",
        color: "#374151",
        textAlign: "center",
        padding: "24px 16px",
        borderTop: "1px solid #e5e7eb",
        marginTop: 28,
      }}
    >
      <div style={{ fontSize: 16, marginBottom: 8 }}>
        {/* <a
          href="https://beian.miit.gov.cn"
          target="_blank"
          rel="noreferrer"
          style={{
            color: "#21C4B8",
            textDecoration: "none",
            transition: "color 0.2s ease",
          }}
          onMouseEnter={(e) => {
            const target = e.target as HTMLElement;
            target.style.color = "#4BA67A";
          }}
          onMouseLeave={(e) => {
            const target = e.target as HTMLElement;
            target.style.color = "#21C4B8";
          }}
        >
          {t("layout.footer_icp")}
        </a> */}
      </div>
      <div style={{ fontSize: isMobile ? 12 : 14 }}>
        © {t("layout.footer_copyright")}
      </div>

      {/* 悬浮按钮 - 加入内测联盟按钮 */}
      {showBetaButton && auditStatus != "1" && auditStatus != "2" && (
        <div
          style={{
            position: "fixed",
            bottom: 140,
            right: 5,
            zIndex: 100,
            borderRadius: "60px",
            background: "#2BBDB0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 12px rgba(43, 189, 178, 0.3)",
            cursor: "pointer",
            transition: "all 0.3s ease",
            fontSize: "12px",
            fontWeight: "bold",
            color: "#ffffff",
            textAlign: "center",
            wordBreak: "break-word",
            lineHeight: "1.2",
            padding: "10px 15px",
          }}
          onClick={joinBetaProgram}
        >
          <span>{t("navbar.menu_join")}</span>
          <div
            style={{
              position: "absolute",
              top: "-10px",
              right: "0px",
              width: "20px",
              height: "20px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={closeBetaButton}
          >
            <img
              src={closeIcon}
              alt="关闭"
              style={{ width: "20px", height: "20px" }}
            />
          </div>
        </div>
      )}
    </AntFooter>
  );
};

export default Footer;
